import { ASSET_ENDPOINT } from "../../../components/Service"
import { noImageHandle } from "../../../components/CommonMethod";

const AboutAuthor = (props) => {
    return(
        <section className="home-section6">
            <div className="container container-1180">
                <div className="row justify-content-center g-4">
                    <div className="col-md-5 col-lg-4 col-xl-3 ">
                        <div className="ratio ratio-1x1 mmw-256">
                            <div className="ratio ratio-1x1 position-absolute bg-lime rounded-circle bottom-0 end-0">
                                <img className="w-100 rounded-circle" src={ props.aboutContent && props.aboutContent.author_image ? ASSET_ENDPOINT + props.aboutContent.author_image : 'images/fly.png' } onError={noImageHandle} style={{objectFit:"cover"}} alt="fly"/>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7 col-lg-8 col-xl-9">
                        <div className="d-flex align-items-start justify-content-start mb-4 gap-2">
                            <svg className="icon mmwh-35 sm-mmwh-28 text-green">
                                <use href="#icon_subtract"></use>
                            </svg>
                            <h2 className="fw-bold mb-0 fs-32"> About The Founder</h2>
                        </div>
                        <div className="h4 fw-normal" dangerouslySetInnerHTML={{ __html: props.aboutContent?.author_description }} />
                        {/* <p className="h4 fw-normal mb-4">{ props.aboutContent && props.aboutContent.author_description }</p> */}
                        {/* <button type="button" className="btn btn-theme-primary btn-lg mt-2 me-3">Info #1</button>
                        <button type="button" className="btn btn-outline-default btn-lg mt-2">Info #2</button> */}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AboutAuthor